import InputAuxiliary from './InputAuxiliary';

export default InputAuxiliary;
